import request from '@/router/axios'

export function sendCode(obj) {
  return request({
    url: '/chain/uniapp/codeByPc',
    method: 'get',
    params: obj
  })
}
export function codeCheck(obj) {
  return request({
    url: '/chain/uniapp/codeCheck',
    method: 'get',
    params: obj
  })
}
export function codeByPcNotUser(obj) {
  return request({
    url: '/chain/uniapp/codeByPcNotUser',
    method: 'get',
    params: obj
  })
}
